import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderProductUnMarkedAsIgnoredByOrderPrice(
        props: TypicalMessageProps<'order-product.unmarked-as-ignored-by-price'>
) {
    return <TypicalMessage
            model={props.model}
            options={props.options}
            optionsKey={props.optionsKey}
    />;
}
